// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Parser = require("../Data.Argonaut.Parser/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Random_LCG = require("../Random.LCG/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Action_DropItem = require("../Ritoppu.Action.DropItem/index.js");
var Ritoppu_Action_IncreaseStats = require("../Ritoppu.Action.IncreaseStats/index.js");
var Ritoppu_Action_Move = require("../Ritoppu.Action.Move/index.js");
var Ritoppu_Action_PickUp = require("../Ritoppu.Action.PickUp/index.js");
var Ritoppu_Action_UseItem = require("../Ritoppu.Action.UseItem/index.js");
var Ritoppu_Display = require("../Ritoppu.Display/index.js");
var Ritoppu_DisplayLog = require("../Ritoppu.DisplayLog/index.js");
var Ritoppu_DungeonGenerator = require("../Ritoppu.DungeonGenerator/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_CreatureType = require("../Ritoppu.Model.CreatureType/index.js");
var Ritoppu_Model_Direction = require("../Ritoppu.Model.Direction/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_Inventory = require("../Ritoppu.Model.Inventory/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Level = require("../Ritoppu.Model.Level/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Model_Tile = require("../Ritoppu.Model.Tile/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var Ritoppu_Random = require("../Ritoppu.Random/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var Web_Storage_Storage = require("../Web.Storage.Storage/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var KeyboardDown = (function () {
    function KeyboardDown(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    KeyboardDown.create = function (value0) {
        return function (value1) {
            return new KeyboardDown(value0, value1);
        };
    };
    return KeyboardDown;
})();
var Idle = (function () {
    function Idle(value0) {
        this.value0 = value0;
    };
    Idle.create = function (value0) {
        return new Idle(value0);
    };
    return Idle;
})();
var Dead = (function () {
    function Dead(value0) {
        this.value0 = value0;
    };
    Dead.create = function (value0) {
        return new Dead(value0);
    };
    return Dead;
})();
var UseItem = (function () {
    function UseItem(value0) {
        this.value0 = value0;
    };
    UseItem.create = function (value0) {
        return new UseItem(value0);
    };
    return UseItem;
})();
var DropItem = (function () {
    function DropItem(value0) {
        this.value0 = value0;
    };
    DropItem.create = function (value0) {
        return new DropItem(value0);
    };
    return DropItem;
})();
var Targeting = (function () {
    function Targeting(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Targeting.create = function (value0) {
        return function (value1) {
            return new Targeting(value0, value1);
        };
    };
    return Targeting;
})();
var MainMenu = (function () {
    function MainMenu(value0) {
        this.value0 = value0;
    };
    MainMenu.create = function (value0) {
        return new MainMenu(value0);
    };
    return MainMenu;
})();
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var LevelUp = (function () {
    function LevelUp(value0) {
        this.value0 = value0;
    };
    LevelUp.create = function (value0) {
        return new LevelUp(value0);
    };
    return LevelUp;
})();
var InitGame = (function () {
    function InitGame() {

    };
    InitGame.value = new InitGame();
    return InitGame;
})();
var MouseClick = (function () {
    function MouseClick(value0) {
        this.value0 = value0;
    };
    MouseClick.create = function (value0) {
        return new MouseClick(value0);
    };
    return MouseClick;
})();
var saveGameStorageKey = "savedGame";
var saveGame = function (game) {
    return Control_Bind.bind(Effect.bindEffect)(Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.localStorage))(Web_Storage_Storage.setItem(saveGameStorageKey)(Data_Argonaut_Core.stringify(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Ritoppu_Model_Creature.encodeJsonAiStrategy)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "power";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "maxHp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "hp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "defense";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Ritoppu_Model_CreatureType.encodeJsonCreatureType)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "xp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "type";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "turn";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "stats";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "aiStrategy";
    }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeSet(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Data_Argonaut_Encode_Class.encodeJsonJBoolean))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "visible";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "seen";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Data_Argonaut_Encode_Class.encodeJsonArray(Ritoppu_Model_Item.encodeJsonItem)))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Ritoppu_Model_Equipment.encodeJsonMainHandItem))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonMaybe(Ritoppu_Model_Equipment.encodeJsonOffHandItem))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "offHand";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "mainHand";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Ritoppu_Model_Item.ordItem)(Ritoppu_Model_Item.encodeJsonItem)(Data_Argonaut_Encode_Class.encodeJsonInt))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "currentXp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "currentLevel";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "power";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "maxHp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "hp";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "defense";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "turn";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "stats";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "pos";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "level";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "inventory";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "equipment";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeSet(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())()))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))())())(Ritoppu_Model_Tile.encodeJsonTile))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "tiles";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "seen";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "player";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "items";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "fovMask";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "creatures";
    }))())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "stage";
    }))())(new Data_Symbol.IsSymbol(function () {
        return "dungeonLevel";
    }))())())(game))));
};
var renderEquipment = function (v) {
    return [ Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Main hand") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Maybe.maybe("-")(Data_Show.show(Ritoppu_Model_Equipment.showMainHandItem))(v.mainHand)) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Off hand") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Maybe.maybe("-")(Data_Show.show(Ritoppu_Model_Equipment.showOffHandItem))(v.offHand)) ]) ];
};
var mainMenuKeyAct = function (mGame) {
    return function (key) {
        var $44 = {
            key: key,
            mGame: mGame
        };
        if ($44.key === "n") {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(Random_LCG.randomSeed))(function (v) {
                var game = {
                    stage: Ritoppu_Mutation_Stage.updateFov(Ritoppu_Random.runGenerator(v)(Ritoppu_DungeonGenerator.generator(1)({
                        x: 30,
                        y: 30
                    }))),
                    dungeonLevel: 1
                };
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(saveGame(game)))(function () {
                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                        var $46 = {};
                        for (var $47 in v1) {
                            if ({}.hasOwnProperty.call(v1, $47)) {
                                $46[$47] = v1[$47];
                            };
                        };
                        $46.state = new Idle(game);
                        return $46;
                    });
                });
            });
        };
        if ($44.key === "c" && $44.mGame instanceof Data_Maybe.Just) {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                var $50 = {};
                for (var $51 in v) {
                    if ({}.hasOwnProperty.call(v, $51)) {
                        $50[$51] = v[$51];
                    };
                };
                $50.state = new Idle($44.mGame.value0);
                return $50;
            });
        };
        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
    };
};
var loadGame = function __do() {
    var v = Control_Bind.bind(Effect.bindEffect)(Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.localStorage))(Web_Storage_Storage.getItem(saveGameStorageKey))();
    if (v instanceof Data_Maybe.Just) {
        var v1 = Data_Argonaut_Parser.jsonParser(v.value0);
        if (v1 instanceof Data_Either.Left) {
            Effect_Console.log(v1.value0)();
            return Data_Maybe.Nothing.value;
        };
        if (v1 instanceof Data_Either.Right) {
            var v2 = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonMaybe(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Ritoppu_Model_Creature.decodeJsonAiStrategy)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "power";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "maxHp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "hp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "defense";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Ritoppu_Model_CreatureType.decodeJsonCreatureType)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "xp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "type";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "turn";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "stats";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "aiStrategy";
            }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeSet(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "visible";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "seen";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Data_Argonaut_Decode_Class.decodeArray(Ritoppu_Model_Item.decodeJsonItem)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonMaybe(Ritoppu_Model_Equipment.decodeJsonMainHandItem))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonMaybe(Ritoppu_Model_Equipment.decodeJsonOffHandItem))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "offHand";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "mainHand";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Ritoppu_Model_Item.ordItem)(Ritoppu_Model_Item.decodeJsonItem)(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "currentXp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "currentLevel";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "power";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "maxHp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "hp";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "defense";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "turn";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "stats";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "pos";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "level";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "inventory";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "equipment";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeSet(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))()())())(Ritoppu_Model_Tile.decodeJsonTile))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "tiles";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "size";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "seen";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "player";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "items";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "fovMask";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "creatures";
            }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "stage";
            }))()())(new Data_Symbol.IsSymbol(function () {
                return "dungeonLevel";
            }))()())()))(v1.value0);
            if (v2 instanceof Data_Either.Left) {
                Effect_Console.log(v2.value0)();
                return Data_Maybe.Nothing.value;
            };
            if (v2 instanceof Data_Either.Right) {
                return v2.value0;
            };
            throw new Error("Failed pattern match at Ritoppu.Component.App (line 451, column 11 - line 455, column 36): " + [ v2.constructor.name ]);
        };
        throw new Error("Failed pattern match at Ritoppu.Component.App (line 446, column 7 - line 455, column 36): " + [ v1.constructor.name ]);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Data_Maybe.Nothing.value;
    };
    throw new Error("Failed pattern match at Ritoppu.Component.App (line 444, column 3 - line 456, column 28): " + [ v.constructor.name ]);
};
var inventoryItems = function (game) {
    return Data_Array.concatMap(function (v) {
        return [ Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text(Ritoppu_Model_Item.itemName(v.value0)) ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(v.value1)) ]) ];
    })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(game.stage.player.inventory));
};
var initialState = {
    state: Init.value,
    logs: [  ]
};
var div = function (classes) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(classes) ]);
};
var gameInterface = function (game) {
    return div("level-map")(Data_Functor.map(Data_Functor.functorArray)(div("row"))(Ritoppu_Display.build(Data_Function["const"]([  ]))(game.stage)));
};
var sidebar = function (game) {
    return div("panel-sidebar")([ div("stats")([ Halogen_HTML_Elements.dl([  ])([ Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Dungeon Level") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.dungeonLevel)) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("HP") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.hp) + (" / " + Data_Show.show(Data_Show.showInt)(game.stage.player.stats.maxHp))) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Level") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.level.currentLevel) + (" (" + (Data_Show.show(Data_Show.showInt)(game.stage.player.level.currentXp) + (" / " + (Data_Show.show(Data_Show.showInt)(Ritoppu_Model_Level.experienceToNextLevel(game.stage.player.level)) + ")"))))) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Power") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.power)) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Defense") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.defense)) ]) ]) ]), Halogen_HTML_Core.text("Inventory:"), div("stats")([ Halogen_HTML_Elements.dl([  ])(inventoryItems(game)) ]), Halogen_HTML_Core.text("Equipment:"), div("stats")([ Halogen_HTML_Elements.dl([  ])(renderEquipment(game.stage.player.equipment)) ]), Halogen_HTML_Elements.hr_, div("help-section")([ div("")([ Halogen_HTML_Core.text("Arrows or vim-keys to move") ]), div("")([ Halogen_HTML_Core.text("z or . to wait") ]), div("")([ Halogen_HTML_Core.text("g or , to pick item up") ]), div("")([ Halogen_HTML_Core.text("d to drop") ]), div("")([ Halogen_HTML_Core.text("a to use an item") ]), div("")([ Halogen_HTML_Core.text("Enter to go downstairs") ]) ]) ]);
};
var sidebar$prime = function (game) {
    var inventoryItems$prime = Data_Array.concatMap(function (v) {
        return [ Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text(v.value0 + (": " + Ritoppu_Model_Item.itemName(v.value1.value0))) ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(v.value1.value1)) ]) ];
    })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Ritoppu_Model_Inventory.inventoryPositions(game.stage.player.inventory)));
    return div("panel-sidebar")([ div("stats")([ Halogen_HTML_Elements.dl([  ])([ Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Dungeon Level") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.dungeonLevel)) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("HP") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.hp) + (" / " + Data_Show.show(Data_Show.showInt)(game.stage.player.stats.maxHp))) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Level") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.level.currentLevel) + (" (" + (Data_Show.show(Data_Show.showInt)(game.stage.player.level.currentXp) + (" / " + (Data_Show.show(Data_Show.showInt)(Ritoppu_Model_Level.experienceToNextLevel(game.stage.player.level)) + ")"))))) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Power") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.power)) ]), Halogen_HTML_Elements.dd([  ])([ Halogen_HTML_Core.text("Defense") ]), Halogen_HTML_Elements.dt([  ])([ Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(game.stage.player.stats.defense)) ]) ]) ]), Halogen_HTML_Core.text("Inventory:"), div("stats")([ Halogen_HTML_Elements.dl([  ])(inventoryItems$prime) ]), Halogen_HTML_Core.text("Equipment:"), div("stats")([ Halogen_HTML_Elements.dl([  ])(renderEquipment(game.stage.player.equipment)) ]), Halogen_HTML_Elements.hr_, div("help-section")([ div("")([ Halogen_HTML_Core.text("Arrows or vim-keys to move") ]), div("")([ Halogen_HTML_Core.text("z or . to wait") ]), div("")([ Halogen_HTML_Core.text("g or , to pick item up") ]), div("")([ Halogen_HTML_Core.text("d to drop") ]), div("")([ Halogen_HTML_Core.text("a to use an item") ]), div("")([ Halogen_HTML_Core.text("Enter to go downstairs") ]) ]) ]);
};
var render = function (app) {
    return div("app-container")((function () {
        if (app.state instanceof MainMenu) {
            return [ div("main-menu")([ div("logo")([ Halogen_HTML_Core.text("RITOPPU") ]), div("option")([ Halogen_HTML_Core.text("[N]ew game") ]), div((function () {
                var $74 = Data_Maybe.isJust(app.state.value0);
                if ($74) {
                    return "option";
                };
                return "option -inactive";
            })())([ Halogen_HTML_Core.text("[C]ontinue last game") ]), div("copyright")([ Halogen_HTML_Core.text("By Ilya Smelkov") ]) ]) ];
        };
        if (app.state instanceof Idle) {
            return [ gameInterface(app.state.value0), Ritoppu_DisplayLog.loggerBlock(app.logs), sidebar(app.state.value0) ];
        };
        if (app.state instanceof LevelUp) {
            return [ gameInterface(app.state.value0), Ritoppu_DisplayLog.loggerBlock(app.logs), sidebar(app.state.value0), div("screen -levelup")([ div("title")([ Halogen_HTML_Core.text("You gained level " + Data_Show.show(Data_Show.showInt)(app.state.value0.stage.player.level.currentLevel)) ]), Halogen_HTML_Core.text("Level up! Choose a stat to raise:"), div("menu-option")([ div("key")([ Halogen_HTML_Core.text("a") ]), div("value")([ Halogen_HTML_Core.text("Constitution (+20 HP, from " + (Data_Show.show(Data_Show.showInt)(app.state.value0.stage.player.stats.maxHp) + ")")) ]) ]), div("menu-option")([ div("key")([ Halogen_HTML_Core.text("b") ]), div("value")([ Halogen_HTML_Core.text("Strength (+1 attack, from " + (Data_Show.show(Data_Show.showInt)(app.state.value0.stage.player.stats.power) + ")")) ]) ]), div("menu-option")([ div("key")([ Halogen_HTML_Core.text("c") ]), div("value")([ Halogen_HTML_Core.text("Agility (+1 defense, from " + (Data_Show.show(Data_Show.showInt)(app.state.value0.stage.player.stats.defense) + ")")) ]) ]) ]) ];
        };
        if (app.state instanceof Dead) {
            return [ gameInterface(app.state.value0), Ritoppu_DisplayLog.loggerBlock(app.logs), div("screen -dead")([ Halogen_HTML_Core.text("YOU DIED") ]), sidebar(app.state.value0) ];
        };
        if (app.state instanceof Targeting) {
            return [ div("level-map")(Data_Functor.map(Data_Functor.functorArray)(div("row"))(Ritoppu_Display.build(function (p) {
                return [ Halogen_HTML_Events.onClick(function (v) {
                    return new Data_Maybe.Just(new MouseClick(p));
                }) ];
            })(app.state.value0.stage))), Ritoppu_DisplayLog.loggerBlock(app.logs), sidebar$prime(app.state.value0) ];
        };
        if (app.state instanceof UseItem) {
            return [ gameInterface(app.state.value0), Ritoppu_DisplayLog.loggerBlock(app.logs), sidebar$prime(app.state.value0) ];
        };
        if (app.state instanceof DropItem) {
            return [ gameInterface(app.state.value0), Ritoppu_DisplayLog.loggerBlock(app.logs), sidebar$prime(app.state.value0) ];
        };
        if (app.state instanceof Init) {
            return [ Halogen_HTML_Core.text("Loading...") ];
        };
        throw new Error("Failed pattern match at Ritoppu.Component.App (line 91, column 34 - line 154, column 6): " + [ app.state.constructor.name ]);
    })());
};
var deleteGame = Control_Bind.bind(Effect.bindEffect)(Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.localStorage))(Web_Storage_Storage.removeItem(saveGameStorageKey));
var processAction = function (dictBind) {
    return function (dictMonadAff) {
        return function (state) {
            return function (v) {
                if (v instanceof Ritoppu_Action.LogMessage) {
                    return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())({
                        logs: Data_Array.take(5)(Data_Array.cons(v.value0)(state.logs)),
                        state: state.state
                    });
                };
                if (v instanceof Ritoppu_Action.Die) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(dictBind)(Effect_Class.liftEffect(dictMonadAff.MonadEffect0())(deleteGame))(function () {
                        return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())({
                            state: new Dead(v.value0),
                            logs: state.logs
                        });
                    });
                };
                if (v instanceof Ritoppu_Action.Target) {
                    return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())({
                        state: new Targeting(v.value0, v.value1),
                        logs: state.logs
                    });
                };
                if (v instanceof Ritoppu_Action.LevelUp) {
                    return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())({
                        state: new LevelUp(v.value0),
                        logs: state.logs
                    });
                };
                throw new Error("Failed pattern match at Ritoppu.Component.App (line 322, column 23 - line 331, column 42): " + [ v.constructor.name ]);
            };
        };
    };
};
var cancelKeyAct = function (key) {
    return function (game) {
        if (key === "Escape") {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                var $90 = {};
                for (var $91 in v) {
                    if ({}.hasOwnProperty.call(v, $91)) {
                        $90[$91] = v[$91];
                    };
                };
                $90.state = new Idle(game);
                return $90;
            });
        };
        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
    };
};
var autoSave = true;
var action = function (f) {
    return function (game) {
        var v = f(game);
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Foldable.foldM(Data_Foldable.foldableArray)(Halogen_Query_HalogenM.monadHalogenM)(processAction(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff)))({
                state: new Idle(v.result),
                logs: v1.logs
            })(v.actions))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)))(function () {
                return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(autoSave)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v2) {
                    if (v2.state instanceof Idle) {
                        return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(saveGame(v2.state.value0));
                    };
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                }));
            });
        });
    };
};
var downstairs = function (game) {
    var v = Ritoppu_Model_Stage.tileAt(game.stage)(game.stage.player.pos);
    if (v instanceof Ritoppu_Model_Tile.StairsDown) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
            var $102 = {};
            for (var $103 in v1) {
                if ({}.hasOwnProperty.call(v1, $103)) {
                    $102[$103] = v1[$103];
                };
            };
            $102.state = new DropItem(game);
            return $102;
        }))(function () {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(Random_LCG.randomSeed))(function (v1) {
                var nextDungeonLevel = game.dungeonLevel + 1 | 0;
                var newStage = Ritoppu_Random.runGenerator(v1)(Ritoppu_DungeonGenerator.generator(nextDungeonLevel)({
                    x: 30,
                    y: 30
                }));
                return action(function (g) {
                    return Ritoppu_Action.withAction(g)(new Ritoppu_Action.LogMessage(Ritoppu_Action.DownstairsRest.value));
                })({
                    stage: Ritoppu_Mutation_Stage.updateFov({
                        player: {
                            pos: newStage.player.pos,
                            stats: Ritoppu_Mutation_Stats.heal(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(game.stage.player.stats.maxHp)(2))(game.stage.player.stats),
                            turn: 0,
                            inventory: game.stage.player.inventory,
                            level: game.stage.player.level,
                            equipment: game.stage.player.equipment
                        },
                        tiles: newStage.tiles,
                        size: newStage.size,
                        seen: newStage.seen,
                        items: newStage.items,
                        fovMask: newStage.fovMask,
                        creatures: newStage.creatures
                    }),
                    dungeonLevel: nextDungeonLevel
                });
            });
        });
    };
    return action(function (g) {
        return Ritoppu_Action.withAction(g)(new Ritoppu_Action.LogMessage(Ritoppu_Action.NoStairs.value));
    })(game);
};
var handleAction = function (v) {
    if (v instanceof InitGame) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(Random_LCG.randomSeed))(function (v1) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(Effect_Aff.monadEffectAff))(loadGame))(function (v2) {
                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v3) {
                    var $109 = {};
                    for (var $110 in v3) {
                        if ({}.hasOwnProperty.call(v3, $110)) {
                            $109[$110] = v3[$110];
                        };
                    };
                    $109.state = new MainMenu(v2);
                    return $109;
                });
            });
        });
    };
    if (v instanceof MouseClick) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            if (v1.state instanceof Targeting) {
                return action(v1.state.value1(v.value0))(v1.state.value0);
            };
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
        });
    };
    throw new Error("Failed pattern match at Ritoppu.Component.App (line 276, column 16 - line 291, column 18): " + [ v.constructor.name ]);
};
var idleKeyAct = function (v) {
    if (v === "y") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.NW.value));
    };
    if (v === "u") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.NE.value));
    };
    if (v === "b") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.SW.value));
    };
    if (v === "n") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.SE.value));
    };
    if (v === "h") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.W.value));
    };
    if (v === "j") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.S.value));
    };
    if (v === "k") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.N.value));
    };
    if (v === "l") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.E.value));
    };
    if (v === "ArrowLeft") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.W.value));
    };
    if (v === "ArrowDown") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.S.value));
    };
    if (v === "ArrowUp") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.N.value));
    };
    if (v === "ArrowRight") {
        return action(Ritoppu_Action_Move.move(Ritoppu_Model_Direction.E.value));
    };
    if (v === ".") {
        return action(Ritoppu_Action_Move.wait);
    };
    if (v === "z") {
        return action(Ritoppu_Action_Move.wait);
    };
    if (v === ",") {
        return action(Ritoppu_Action_PickUp.pickUp);
    };
    if (v === "g") {
        return action(Ritoppu_Action_PickUp.pickUp);
    };
    if (v === "a") {
        return function (game) {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                var $119 = {};
                for (var $120 in v1) {
                    if ({}.hasOwnProperty.call(v1, $120)) {
                        $119[$120] = v1[$120];
                    };
                };
                $119.state = new UseItem(game);
                return $119;
            });
        };
    };
    if (v === "d") {
        return function (game) {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                var $122 = {};
                for (var $123 in v1) {
                    if ({}.hasOwnProperty.call(v1, $123)) {
                        $122[$123] = v1[$123];
                    };
                };
                $122.state = new DropItem(game);
                return $122;
            });
        };
    };
    if (v === "Enter") {
        return downstairs;
    };
    return action(Ritoppu_Action.inactive);
};
var levelUpKeyAct = function (key) {
    return function (game) {
        if (key === "a") {
            return action(Ritoppu_Action_IncreaseStats.increaseMaxHp(20))(game);
        };
        if (key === "b") {
            return action(Ritoppu_Action_IncreaseStats.increasePower(1))(game);
        };
        if (key === "c") {
            return action(Ritoppu_Action_IncreaseStats.increaseDefense(1))(game);
        };
        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
    };
};
var withItemKeyAct = function (key) {
    return function (f) {
        return function (game) {
            var foundItem = Data_Map_Internal.lookup(Data_Ord.ordString)(key)(Ritoppu_Model_Inventory.inventoryPositions(game.stage.player.inventory));
            var $126 = {
                key: key,
                item: foundItem
            };
            if ($126.key === "Escape") {
                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                    var $127 = {};
                    for (var $128 in v) {
                        if ({}.hasOwnProperty.call(v, $128)) {
                            $127[$128] = v[$128];
                        };
                    };
                    $127.state = new Idle(game);
                    return $127;
                });
            };
            if ($126.item instanceof Data_Maybe.Nothing) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(processAction(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(v)(new Ritoppu_Action.LogMessage(Ritoppu_Action.DoNotHave.value)))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)))(function () {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            var $132 = {};
                            for (var $133 in v1) {
                                if ({}.hasOwnProperty.call(v1, $133)) {
                                    $132[$133] = v1[$133];
                                };
                            };
                            $132.state = new Idle(game);
                            return $132;
                        });
                    });
                });
            };
            if ($126.item instanceof Data_Maybe.Just) {
                return action(f($126.item.value0.value0))(game);
            };
            throw new Error("Failed pattern match at Ritoppu.Component.App (line 408, column 29 - line 415, column 27): " + [ $126.constructor.name ]);
        };
    };
};
var handleQuery = function (v) {
    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
        if (v1.state instanceof Idle) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(idleKeyAct(Web_UIEvent_KeyboardEvent.key(v.value0))(v1.state.value0))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof UseItem) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(withItemKeyAct(Web_UIEvent_KeyboardEvent.key(v.value0))(Ritoppu_Action_UseItem.useItem)(v1.state.value0))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof DropItem) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(withItemKeyAct(Web_UIEvent_KeyboardEvent.key(v.value0))(Ritoppu_Action_DropItem.dropItem)(v1.state.value0))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof Targeting) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(cancelKeyAct(Web_UIEvent_KeyboardEvent.key(v.value0))(v1.state.value0))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof MainMenu) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(mainMenuKeyAct(v1.state.value0)(Web_UIEvent_KeyboardEvent.key(v.value0)))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof LevelUp) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(levelUpKeyAct(Web_UIEvent_KeyboardEvent.key(v.value0))(v1.state.value0))(function () {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            });
        };
        if (v1.state instanceof Dead) {
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        };
        if (v1.state instanceof Init) {
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        };
        throw new Error("Failed pattern match at Ritoppu.Component.App (line 297, column 5 - line 319, column 25): " + [ v1.state.constructor.name ]);
    });
};
var component = Halogen_Component.mkComponent({
    initialState: Data_Function["const"](initialState),
    render: render,
    "eval": Halogen_Component.mkEval({
        handleAction: handleAction,
        handleQuery: handleQuery,
        receive: Halogen_Component.defaultEval.receive,
        initialize: new Data_Maybe.Just(InitGame.value),
        finalize: Halogen_Component.defaultEval.finalize
    })
});
module.exports = {
    component: component,
    KeyboardDown: KeyboardDown
};
